import React, { useEffect, useState, useContext } from 'react'
import axios from "axios";
import CircularProgress from '@mui/material/CircularProgress';
import Backdrop from '@mui/material/Backdrop';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid'; // Grid version 1
import Layout from '../../components/Layout';
import { GlobalContext } from '../../contexts/GlobalContext'
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useParams } from "react-router-dom";
import { format, parse } from 'date-fns'
import { IconPlus } from '@tabler/icons-react';
import Fab from '@mui/material/Fab';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import InputLabel from '@mui/material/InputLabel';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import UploadButton from '../../components/VoucherUploader';
import CheckinButton from '../../components/CheckinButton';
import NewCheckinButton from '../../components/NewCheckinButton';
import LoadingComponent from '../../components/LoadingComponent';

function SupplierCheckins() {
    let { status } = useParams();
    const navigate = useNavigate();
    const { url, phone, setPhone, contact, setContact, customer, setCustomer, customerName, setCustomerName, token, setToken, ledgers  } = useContext(GlobalContext);
    const [loading, setLoading] = useState(true);
 
    const [items, setItems] = useState([]);
    const [hasMore, setHasMore] = useState(true);

    const [currentPage, setCurrentPage] = useState(0);

    const handleChange = (event, newStatus) => {
        console.log("newStatus", newStatus);
        setItems([]);
        setHasMore(true);
        setCurrentPage(0);
        return navigate("/supplier/checkins/" + newStatus)
    };
    
    useEffect(() => {
        setItems([]);
        setHasMore(true);
        setCurrentPage(0);
        fetchData();
        if(window.cordova) {
            FirebasePlugin.setScreenName("Checkins");
        }
    }, [ status ]);

    const fetchData = () => {
        var page = currentPage + 1;
        axios.post( url + 'api/suppliers/visits?page=' + page, {
            customer: customer,
            contact: contact,
            phone: phone,
            status: status,
        }, { headers: { Authorization: `Bearer ${token}` }})
        .then(function (response) {
            setItems((prev) => [...prev, ...response.data.data]);
            setCurrentPage(parseInt(response.data.current_page));
            if(response.data.current_page == response.data.last_page) {
                setHasMore(false);
            }
            setLoading(false);
        })
        .catch(function (error) {
            console.log(error);
        });
    } 

    function ItemAction (prop) {
        if(prop.status == 1) {
            return (<CheckinButton creator="2" id={prop.id}  />);
        } else if (prop.status == 2) {
            return (<UploadButton buttonType="button" title="Order" seller={customer} buyer={prop.buyer} link={prop.id} voucher_type="orders" />);
        }
    }
    
    const Item = (prop) => {
        return (
            <Paper sx={{ border: 1, borderColor: 'divider', cursor: 'pointer', width: '100%', maxWidth: '100%', textAlign: 'center', mt: 4 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 2, py:1 }}>
                    <Typography variant="h6" component="h6">{prop.data.buyer_name}</Typography>
                </Box>
                <Grid container>
                    <Grid item xs={12} sx={{borderColor: 'divider', px: 1, py:1 }}>
                        <Typography variant="overline" component="p">Date</Typography>
                        <Typography variant="body" component="p">{prop.data.date ? format(parse(prop.data.date, 'yyyy-MM-dd HH:mm:ss', new Date()), 'dd MMM yyyy') : ''}</Typography>
                    </Grid>
                </Grid>
                <Box sx={{ borderTop: 1, borderColor: 'divider',  display: 'flex', flexDirection: 'column', gap: 3, p: 1 }}>
                    <ItemAction status={prop.data.status} id={prop.data.id} order={prop.data.order_id} buyer={prop.data.buyer} />
                </Box>
            </Paper>
        )
    }

    return (
        <div>
        {  loading ? 
            <LoadingComponent loading={loading} />
            : 
            <Layout title="Check-Ins" backToHome="true">
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs variant="scrollable" scrollButtons allowScrollButtonsMobile value={parseInt(status)} onChange={handleChange}>
                        <Tab label="Upcoming" />
                        <Tab label="Checked-In" />
                        <Tab label="Ordered" />
                    </Tabs>

                    <InfiniteScroll scrollThreshold={0.5} dataLength={items.length} next={fetchData} style={{ display: 'flex', flexDirection: 'column' }} inverse={false} hasMore={hasMore} loader={<p style={{ textAlign: 'center', fontSize: '14px' }}>Loading...</p>} endMessage={<p style={{ textAlign: 'center', fontSize: '14px' }}>You have reached end of the list</p>}>
                    {items.map((row, index) => (
                        <Item key={row.id} data={row}></Item>
                    ))}
                    </InfiniteScroll>
                </Box>
                <NewCheckinButton creator="2" />
            </Layout>
        }
        </div>
    );
}

export default SupplierCheckins;
